import { Flex, FlexProps } from '@chakra-ui/react';
import React from 'react';

export const CmFlex: React.FC<FlexProps> = ({ children, ...rest }) => {
  // @ts-ignore TS2590
  return <Flex {...rest}>{children}</Flex>;
};
